import { z, uuidSchema, phoneE164Schema } from '@kc3/validation';
import { baseEventFields } from './_base.js';
import { DialerTypeSchema, CallOutcomeSchema, DialerKindSchema, DialerDispositionSchema, } from '../enums/index.js';
export const DialerOriginateEventSchema = z.object({
    type: z.literal('dialer.originate'),
    ...baseEventFields,
    campaignId: uuidSchema,
    attemptId: uuidSchema,
    destination: phoneE164Schema,
    dialerType: DialerTypeSchema,
});
export const DialerAttemptCompletedEventSchema = z.object({
    type: z.literal('dialer.attempt_completed'),
    ...baseEventFields,
    campaignId: uuidSchema,
    attemptId: uuidSchema,
    outcome: CallOutcomeSchema,
    durationSeconds: z.number().int().nonnegative(),
});
/**
 * Phase 5 Task 2 — `dialer.attempt.started`.
 *
 * Emitted by `ManualDialer.recordManualDial` and by
 * `PreviewDialer.dial` (and Task 3+ engines) immediately after the
 * compliance gate passes and before AriPool.originate runs. Worker
 * consumers (CDR pipeline, supervisor live dashboard) settle on this
 * event to start a per-attempt timeline.
 *
 * Nullability semantics:
 *   - `campaignId` — null for ad-hoc manual click-to-dial outside a
 *     campaign. PreviewDialer always supplies a non-null id.
 *   - `contactId`  — null for ad-hoc manual where no Phase 5
 *     `tenant_<slug>.contacts` row exists.
 *   - `agentId`    — null for predictive / power (no human pre-bound
 *     to the originate). MANUAL + PREVIEW are always agent-bound.
 */
export const DialerAttemptStartedEventSchema = z.object({
    type: z.literal('dialer.attempt.started'),
    ...baseEventFields,
    attemptId: uuidSchema,
    campaignId: uuidSchema.nullable(),
    contactId: uuidSchema.nullable(),
    agentId: uuidSchema.nullable(),
    phone: phoneE164Schema,
    dialerType: DialerKindSchema,
    callId: uuidSchema,
});
/**
 * Phase 5 Task 2 placeholder — `dialer.attempt.done` (NOTE: distinct
 * routing key from the legacy `dialer.attempt_completed` to avoid
 * colliding with the existing Phase 1 schema). Wired in by Task 3+
 * engines once disposition reporting is connected; declared here so
 * dashboards / topology-tests can reference the contract today.
 */
export const DialerAttemptDoneEventSchema = z.object({
    type: z.literal('dialer.attempt.done'),
    ...baseEventFields,
    attemptId: uuidSchema,
    disposition: DialerDispositionSchema,
    durationSec: z.number().int().nonnegative(),
});
//# sourceMappingURL=dialer.js.map